import { Environment } from "src/libs/environment";
import { Platform } from "src/libs/platform";
import { Chat, ChatProviders } from "src/shared/services/chat/chat-service";
import { store } from "src/redux/store";
import { toggleVeraWhatsappModal } from "src/redux/ui/actions";

export class VeraChat implements Chat {
    private isChatFeatureOn = Environment.bool("CHAT_FEATURE_ON");
    private chatProvider = Environment.string("CHAT_PROVIDER");

    show(): Promise<void> {
        return new Promise((resolve) => {
            store.dispatch(toggleVeraWhatsappModal());
            resolve();
        });
    }

    hide(): Promise<void> {
        return Promise.resolve();
    }

    shouldShow(): boolean {
        return (
            this.isChatFeatureOn &&
            Platform.isRunningOnFlutter() &&
            this.chatProvider === ChatProviders.Whatsapp
        );
    }
}
